export default "__VITE_ASSET__DRjBukCt__"